const config = {
  assetsBaseUrl: '/assets/',
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  Auth: {
    region: process.env.REACT_APP_AMPLIFY_REGION,
    userPoolId: process.env.REACT_APP_AMPLIFY_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
    // identityPoolId: process.env.REACT_APP_AMPLIFY_IDENTITY_POOL_ID,
  },
  auth: {
    aws_cognito_region: process.env.REACT_APP_AMPLIFY_REGION,
    aws_user_pools_id: process.env.REACT_APP_AMPLIFY_USER_POOL_ID,
    aws_user_pools_web_client_id:
      process.env.REACT_APP_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
    oauth: {
      redirectSignIn: `${process.env.REACT_APP_PUBLIC_SITE_URL}/auth/callback`,
      redirectSignOut: `${process.env.REACT_APP_PUBLIC_SITE_URL}/`,
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    claims: 'https://canalizzazione.arval.it/jwt/claims',
    mfaPrefix: process.env.REACT_APP_MFA_PREFIX,
  },
}

export default config
